import { useField } from 'formik';

import {
  FieldGroup, Label, Textarea, Error,
} from '..';

import type { ITextareaInput } from '../types';

const TextareaInput = ({
  label,
  placeholder = ' ',
  autofocus,
  rows = 3,
  backgroundColor = 'dark',
  ...props
}: ITextareaInput) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);

  return (
    <FieldGroup>
      <Label $backgroundColor={backgroundColor} htmlFor={props.id || props.name}>{label}</Label>
      <Textarea rows={rows} $backgroundColor={backgroundColor} hasError={Boolean(meta.touched && meta.error)} placeholder={placeholder} {...field} {...props} autoFocus={autofocus} />
      {(meta.touched && meta.error) && <Error $backgroundColor={backgroundColor}>{meta.error}</Error>}
    </FieldGroup>
  );
};

export default TextareaInput;
